import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import JsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';

export function configureMonacoWorkerEnvironment() {
  window.MonacoEnvironment = {
    getWorker(_moduleId: unknown, label: string) {
      if (label === 'json') return new JsonWorker();
      return new EditorWorker();
    },
  };
}
